module.exports = __webpack_public_path__ + "img/firstService.a8359e4e.svg";